module.exports = __webpack_public_path__ + "img/service.c45a0dc5.svg";